import styled from 'styled-components';

export const FilterOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${props => (props.selected ? '#3b4e5e' : 'white')};
  width: 165px;
  border: 1px solid white;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #3b4e5e inset;
  box-sizing: border-box;
  font-size: 13px;
  margin: 5px 10px 5px 0;
  padding: 1px;
  background-color: ${props => (props.selected ? 'white' : '#3b4e5e')};
  cursor: pointer;

  &:hover {
    color: ${props => (props.selected ? '#3b4e5e' : 'white')};
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  [class^='svgIconComponent'] {
    width: 23px !important;
    margin-top: 5px;

    path {
      fill: white !important;
    }
  }
`;

export const InfoTooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.2s, opacity 0.2s;
  position: absolute;
  top: 0;
  left: 45px;
  background: white;
  width: 190px;
  border: 1px grey solid;
  border-radius: 5px;
  transform: translate(0, -30%);

  &:before,
  &:after {
    bottom: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    transform: rotate(-90deg) translate(50%, 0);
  }

  &:before {
    border-color: rgba(194, 194, 194, 0);
    border-bottom-color: grey;
    border-width: 11px;
    right: 191px;
    top: 50%;
  }

  &:after {
    top: 50%;
    right: 189px;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: white;
    border-width: 11px;

    @media screen and (max-width: 1300px) {
      right: 190px;
    }
  }
`;

export const InfoIcon = styled.div`
  position: relative;
  cursor: help;

  &:hover ${InfoTooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const InfoTooltipText = styled.p`
  background: white;
  color: black;
  margin: 5px 10px;
`;
